import $ from "jquery";

const preloadScreenshotImages = function () {
  if (typeof window.preloader === "undefined") {
    return;
  }
  $(".screenshot-buttons a[data-screenshot-url]").map(function (i, e) {
    window.preloader.addUrl($(e).data("screenshot-url"));
  }).toArray();
};

const animateImageChange = function(img, url, speed = 1000) {
  img.animate({ opacity: 0 }, speed, function () {
    img.attr("src", url);
    img.animate({ opacity: 1 }, speed);
  });
};

const screenshotButtonClicked = function (e) {
  e.preventDefault();
  const $this = $(this);
  const url = $this.data("screenshot-url");
  const $screenshot = $("#marketing-screenshot");
  animateImageChange($screenshot, url, 200);
  $screenshot.closest("a").attr("href", url);

  $(".screenshot-buttons a[data-screenshot-url]").removeClass("active");
  $this.addClass("active");
};

$(document).on("turbolinks:load", function () {
  preloadScreenshotImages();
  $(".screenshot-buttons a[data-screenshot-url]").on("click", screenshotButtonClicked);
});
